import { render, staticRenderFns } from "./VariantAttributeOptionSelection.vue?vue&type=template&id=b4891084&scoped=true&"
import script from "./VariantAttributeOptionSelection.vue?vue&type=script&lang=js&"
export * from "./VariantAttributeOptionSelection.vue?vue&type=script&lang=js&"
import style0 from "./VariantAttributeOptionSelection.vue?vue&type=style&index=0&id=b4891084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4891084",
  null
  
)

export default component.exports